import React, { useContext, Component, useRef, useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker, LoadScriptNext } from "@react-google-maps/api";

const containerStyle = {
  width: window.innerWidth > 991 ? "50%" : "100%",
  height: "350px",
  borderRadius: "10px",
  mapTypeId: "satellite",
};

function GoogleMaps() {
  const [lat, setLat] = useState();
  const [lng, setLng] = useState();

  useEffect(() => {
    setLat(47.667283);
    setLng(18.362591);
  }, []);

  return (
    <>
      {lat && (
        <div className="d-flex align-items-center justify-content-center" style={{ width: "100%" }}>
          <LoadScriptNext googleMapsApiKey="AIzaSyC9HpD2r0kOjMAlYqAuB5zB6DV4xPeJCdY">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={{ lat: lat, lng: lng }}
              zoom={14}
              options={{ mapTypeId: "satellite" }}
            >
              <Marker position={{ lat: lat, lng: lng }} />
            </GoogleMap>
          </LoadScriptNext>
        </div>
      )}
    </>
  );
}
export default GoogleMaps;
